/* eslint-disable jsx-a11y/label-has-associated-control */
import {
  Avatar,
  Checkbox,
  ColorPicker,
  DatePicker,
  Empty,
  Input,
  Select,
  Upload,
} from 'antd';
import React, { useEffect, useState } from 'react';
// import InputMask from 'react-input-mask';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { regexInput } from 'utils/regex';
import { log } from 'utils';
import 'react-quill/dist/quill.snow.css';
import { fetchInformationCategories } from 'state/actions/informationCategories';
import { setInformation } from 'state/actions/information';
import './AddWebPagesForm.css';

import { EmptyIcon } from 'assets/icon/bigicon';
import DummyTemplateImage from 'assets/dummy-template/dummy-1.png';
import AddSection from './AddSection';
import { addWebPages, updateWebPages } from 'state/actions/webPages';
import { toastr } from 'react-redux-toastr';
import { imgUrl } from 'utils/url';

const AddWebPagesForm = ({ error, onClose, predefinedData }) => {
  const { siteId, siteName } = useParams();
  const [editingSection, setEditingSection] = useState(null);
  log(error);

  useEffect(() => {
    if (!predefinedData) return;

    dispatch(
      setInformation({
        ...information,
        name: predefinedData.title || '',
        url: predefinedData.url || '',
      })
    );

    if (predefinedData.sections && predefinedData.sections.length > 0) {
      const mappedSections = predefinedData.sections.map((sec) => ({
        id: sec._id || Date.now() + Math.random(),
        sectionId: sec.sectionId,
        title: sec.title,
        content: sec.content,
        template: {
          id: sec.templateId,
          name: sec.templateId,
          image: DummyTemplateImage,
        },
        button: sec.button || {},
        image: sec.image,
        file: null,
      }));

      setSections(mappedSections);
    }
  }, [predefinedData]);

  const [errors, setErrors] = useState(error);

  useEffect(() => {
    setErrors(error);
  }, [error]);

  const { loading, userData, categoriesList, poiList, information, category } =
    useSelector(
      (state) => ({
        loading: state.information.loading,
        userData: state.auth.userData,
        categoriesList: state.informationCategories.list,
        poiList: state.pois.list,
        information: state.information.information,
        category: state.informationCategories.category,
      }),
      shallowEqual
    );

  const uid = userData.id;

  const dispatch = useDispatch();
  const [tempSelectedCategory, setTempSelectedCategory] = useState();
  const [sections, setSections] = useState([]);

  const [columnOne, setColumnOne] = useState('80%');
  const [columnTwo, setColumnTwo] = useState('20%');

  const [openAddSection, setOpenAddSection] = useState(false);
  const [selectedTitlePagesContainer, setSelectedTitlePagesContainer] =
    useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);

  useEffect(() => {
    if (information) {
      setTempSelectedCategory(information.categoryId);
    }
  }, [information]); // eslint-disable-line

  useEffect(() => {
    // fetch floor and poi categories
    // dispatch(fetchFloor({ siteId }));
    dispatch(fetchInformationCategories({ siteId }));
  }, [siteId]); // eslint-disable-line

  const handleChange = (name, value) => {
    dispatch(
      setInformation({
        ...information,
        [name]: value,
      })
    );
  };

  const onSubmitHandler = (event) => {
    try {
      event.preventDefault();

      const formData = new FormData();

      formData.append('title', information.name);
      formData.append('siteId', siteId);
      formData.append('url', information.url || '');
      formData.append('userId', userData.id);

      sections.forEach((section, index) => {
        formData.append(
          `sections[${index}][sectionId]`,
          section.sectionId || ''
        );
        formData.append(`sections[${index}][title]`, section.title || '');
        formData.append(`sections[${index}][content]`, section.content || '');

        formData.append(`sections[${index}][image]`, section.image || '');

        formData.append(
          `sections[${index}][button][text]`,
          section.button?.text || ''
        );

        formData.append(
          `sections[${index}][button][url]`,
          section.button?.url || ''
        );

        formData.append(
          `sections[${index}][templateId]`,
          section.template?.id || ''
        );

        if (section?.file && section.file[0]?.file) {
          formData.append(`sections[${index}][file]`, section.file[0].file);
        }
      });

      if (predefinedData && predefinedData._id) {
        dispatch(updateWebPages(predefinedData._id, formData));
        toastr.success('Success', 'Web Page created successfully');
        onClose();
      } else {
        dispatch(addWebPages(formData));
        toastr.success('Success', 'Web Page created successfully');
        onClose();
      }
    } catch (error) {}
  };

  const addNewSection = () => {
    setSelectedTemplate(null);
    console.log('iniii 2');

    setColumnOne('240px');
    setColumnTwo('100%');
    setOpenAddSection(true);
  };

  const closeAddNewSection = (e) => {
    e.stopPropagation();
    setColumnOne('80%');
    setColumnTwo('20%');
    setOpenAddSection(false);
  };

  const handleAddSection = (newSection, editingSection) => {
    if (editingSection) {
      setSections((prev) =>
        prev.map((sec) => (sec.id === editingSection.id ? newSection : sec))
      );
    } else {
      setSections((prev) => [...prev, newSection]);
    }

    setColumnOne('80%');
    setColumnTwo('20%');
    setOpenAddSection(false);
    setSelectedTemplate(null);
    console.log('iniii');
  };

  const handleRemoveSection = (id) => {
    setSections((prev) => prev.filter((section) => section.id !== id));
  };

  const handleEditSection = (section) => {
    setEditingSection(section);
    setSelectedTemplate(section);

    setColumnOne('240px');
    setColumnTwo('100%');
    setOpenAddSection(true);
  };

  const sectionOne = () => {
    return (
      <div className="section-body">
        <div
          style={{
            width: columnOne,
            height: '100vh',
          }}
        >
          <form className="form-wrapper">
            <div>
              <div className="form">
                <label className="form-label">
                  Title <span className="is-required">*</span>
                </label>
                <Input
                  placeholder="Enter Title"
                  className={`${
                    errors && errors.errors && errors.errors.name
                      ? 'has-error'
                      : ''
                  }`}
                  name="name"
                  value={information.name}
                  onChange={(e) => handleChange('name', e.target.value)}
                />
                {errors && errors.errors && errors.errors.name && (
                  <span className="error-message">
                    {errors.errors.name[0].msg}
                  </span>
                )}
              </div>

              <div className="form">
                <label className="form-label">Url</label>
                <Input
                  placeholder="Enter Url"
                  name="url"
                  type="text"
                  value={information.url}
                  onChange={(e) => handleChange('url', e.target.value)}
                />
                {errors &&
                  errors.errors &&
                  errors.errors.url &&
                  errors.errors.url.map((name, idx) => (
                    <div className="error-message" key={idx}>
                      {name.msg}
                    </div>
                  ))}
              </div>

              <div className="form">
                <label className="form-label">Section</label>

                {sections.length === 0 ? (
                  <div className="web-page-empty">
                    <Empty image={<EmptyIcon />} description="No Section" />
                  </div>
                ) : (
                  <div className="section-list">
                    {sections.map((section) => (
                      <div
                        key={section.id}
                        className="section-item"
                        onClick={() => handleEditSection(section)}
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          padding: '8px 12px',
                          border: '1px solid #eee',
                          borderRadius: '4px',
                          marginBottom: '8px',
                          background: '#fff',
                        }}
                      >
                        <div>
                          {section.template && (
                            <img
                              src={
                                section.file?.[0]?.preview ||
                                (section.image
                                  ? `${imgUrl}/media/${section.image}`
                                  : null) ||
                                section.template?.image
                              }
                              alt={section.template.name}
                              style={{
                                width: '60px',
                                height: '40px',
                                objectFit: 'cover',
                                borderRadius: '4px',
                                border: '1px solid #eee',
                              }}
                            />
                          )}
                          <div style={{ fontWeight: 600 }}>{section.title}</div>
                          <div style={{ fontSize: '12px', color: '#888' }}>
                            {section.sectionId}
                          </div>
                        </div>

                        <button
                          type="button"
                          className="button-secondary"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleRemoveSection(section.id);
                          }}
                          style={{
                            background: '#ff4d4f',
                            color: 'white',
                            border: 'none',
                            padding: '4px 8px',
                            borderRadius: '4px',
                            cursor: 'pointer',
                          }}
                        >
                          Remove
                        </button>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </form>
          <div
            className="button-wrapper"
            style={{ display: 'flex', justifyContent: 'flex-end' }}
          >
            <div>
              {loading ? (
                <button className="button-primary" disabled>
                  Loading...
                </button>
              ) : (
                <button className="btn-primary" onClick={onSubmitHandler}>
                  Submit
                </button>
              )}
            </div>
          </div>
        </div>
        <div
          style={{
            width: columnTwo,
          }}
          className="column-two"
          onClick={addNewSection}
        >
          <span className="label-title">+ Add Section</span>
        </div>
      </div>
    );
  };

  const sectionTwo = () => {
    return (
      <div className="section-body">
        <div
          style={{
            width: columnOne,
            height: '100vh',
            background: '#F2F2F2',
          }}
          className="column-one"
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              width: '240px',
            }}
          >
            <div
              className="title-container"
              style={{
                background: selectedTitlePagesContainer ? '#DBF5F5' : '#FFFFFF',
                borderBottom: selectedTitlePagesContainer
                  ? '2px solid #64D5D2'
                  : 'none',
                color: selectedTitlePagesContainer ? '#404040' : '#9E9E9E',
              }}
              onClick={() => setSelectedTitlePagesContainer(true)}
            >
              <span className="text">Layout</span>
            </div>

            <div
              className="title-container"
              onClick={() => setSelectedTitlePagesContainer(false)}
              style={{
                background: !selectedTitlePagesContainer
                  ? '#DBF5F5'
                  : '#FFFFFF',
                borderBottom: !selectedTitlePagesContainer
                  ? '2px solid #64D5D2'
                  : 'none',
                color: !selectedTitlePagesContainer ? '#404040' : '#9E9E9E',
              }}
            >
              <span className="text">Template</span>
            </div>
          </div>
          <div className="body-container">
            <div className="searchbar">
              <i className="feather-search" />
              <input placeholder="Search" className="search-input" />
            </div>
          </div>
        </div>
        <div
          className="column-two body-section"
          style={{
            width: columnTwo,
          }}
        >
          <div
            style={{
              top: '0',
              right: '0',
              position: 'absolute',
            }}
            className="button-secondary"
            onClick={closeAddNewSection}
          >
            <i className="feather-arrow-left" />
            Back
          </div>
          <AddSection
            onAdd={handleAddSection}
            selectedTemplate={selectedTemplate}
          />
        </div>
      </div>
    );
  };

  return (
    <div
      style={{
        padding: '12px 20px',
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <span
          style={{
            fontSize: '24px',
            fontWeight: 700,
          }}
        >
          Add Page
        </span>
        <div
          style={{
            top: '0',
            right: '0',
            position: 'absolute',
          }}
          onClick={onClose}
          className="button-secondary"
        >
          <i className="feather-arrow-left" />
          Back
        </div>
      </div>

      <div className="addWebPagesForm">
        {!openAddSection && sectionOne()}

        {openAddSection && sectionTwo()}
      </div>
    </div>
  );
};

export default AddWebPagesForm;
